export default {
  namespaced: true,
  state: {
    code: [],
    card: [],
  },

  actions: {},

  getters: {
    code(state) {
      return state.code
    },
    card(state) {
      return state.card
    },
    hasCardAndCode(state) {
      return !!(state.card.length && state.code.length)
    },
  },

  mutations: {
    SET_TARIFF_LIST_CODE(state, data) {
      state.code = data
    },
    SET_TARIFF_LIST_CARD(state, data) {
      state.card = data
    },
  },
}
